var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and manages the characteristics of a damaged small gate including its material and size.
 * touches: declaration, externalDamage, littleGateDamage
 * invariants: Selected characteristics are synchronized with the LittleGateDamage model through updateExternalDamage; size choices are displayed as illustrated options with their business descriptions.
 * inputs: externalDamage, LITTLE_GATE_SIZE_CHOICES, GATE_MATERIAL_CHOICES, changeKey
 * outputs: updates external damage data through updateExternalDamage for material and size; displays validation errors associated with the material and size fields.
 * see: @declaration/components/externalDamage/ExternalDamageComponent, @declaration/constants/externalDamages, @shared/types/api/externalDamage, @shared/types/api/breakInDamage
 */
import Component from 'vue-class-component';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import Select from '@declaration/components/Select.vue';
import { LITTLE_GATE_MATERIAL_PLACEHOLDER, LITTLE_GATE_MATERIAL_TITLE, LITTLE_GATE_SIZE_CHOICES, LITTLE_GATE_SIZE_SUBTITLE, LITTLE_GATE_SIZE_TITLE, } from '@declaration/constants/externalDamages';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { GATE_MATERIAL_CHOICES } from '@shared/constants/breakInDamages/GateConstants';
let LittleGate = class LittleGate extends ExternalDamageComponent {
    get materialTitle() {
        return this.translateExternalDamageKey(LITTLE_GATE_MATERIAL_TITLE);
    }
    get materialPlaceholder() {
        return this.translateExternalDamageKey(LITTLE_GATE_MATERIAL_PLACEHOLDER);
    }
    get sizeTitle() {
        return this.translateExternalDamageKey(LITTLE_GATE_SIZE_TITLE);
    }
    get sizeSubtitle() {
        return this.translateExternalDamageKey(LITTLE_GATE_SIZE_SUBTITLE);
    }
    get sizeChoices() {
        return LITTLE_GATE_SIZE_CHOICES.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            description: choice.descriptionTradKey ? this.$tc(choice.descriptionTradKey) : undefined,
            imageSrc: choice.image,
        }));
    }
    get materialChoices() {
        return GATE_MATERIAL_CHOICES;
    }
    get material() {
        var _a;
        return (_a = this.externalDamage.material) !== null && _a !== void 0 ? _a : null;
    }
    set material(material) {
        this.updateExternalDamage({ material });
    }
    get size() {
        var _a;
        return (_a = this.externalDamage.size) !== null && _a !== void 0 ? _a : null;
    }
    set size(size) {
        this.updateExternalDamage({ size });
    }
};
LittleGate = __decorate([
    Component({
        components: { UiRadio, Select, UiCard },
        props: {
            changeKey: { type: [String, Number], default: null },
        },
    })
], LittleGate);
export default LittleGate;
